import { useEffect } from 'react'
import templateStore from '../../stores/TemplatesStore'
import { ArticleFlat } from '../../types'

const useTemplatePicker = (article: ArticleFlat) => {
  useEffect(() => {
    templateStore.setState({
      isPickerVisible: article?.current_version === 0,
      selectedPickerTemplate: null,
      selectedModalTemplate: null,
    })
  }, [article?.id, article?.current_version])
}

export default useTemplatePicker
